// extracted by mini-css-extract-plugin
module.exports = {"privPolicy":"PrivPolicy_privPolicy__3i7xp","textContainer":"PrivPolicy_textContainer__3LL0R"};